import { useEffect, useState } from "react";

export const useOutletVisibility = (customerSitesLoading: boolean, customerSites: any[]) => {
    const [showOutlet, setShowOutlet] = useState<boolean>(false);

    useEffect(() => {
        if (!customerSitesLoading) {
            const timer = setTimeout(() => {
                setShowOutlet(true);
            }, 250);

            return () => clearTimeout(timer);
        }

        setShowOutlet(false);
        return () => { };
    }, [customerSitesLoading, customerSites]);

    return { showOutlet };
};
